import { render } from "./연혁.vue?vue&type=template&id=5bd4a6a8"
import script from "./연혁.vue?vue&type=script&lang=js"
export * from "./연혁.vue?vue&type=script&lang=js"

import "./연혁.vue?vue&type=style&index=0&id=5bd4a6a8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__